import { Box, CircularProgress } from '@material-ui/core'
import React from 'react'
import { State } from '../../../../const'
import { Indicator, PipelineState } from '../../../../types'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import HelpIcon from '@material-ui/icons/Help'

export function PipelineStateComponent(props: { indicator: Indicator<PipelineState> }) {
  const { indicator } = props
  if (indicator.fetching) {
    return <CircularProgress size={25} />
  } else {
    switch (indicator.value) {
      case State.pending:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Pending</b>
            <AutorenewIcon className='rotate' />
          </Box>
        )
      case State.running:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Running</b>
            <AutorenewIcon className='rotate' />
          </Box>
        )
      case State.stopped:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Stopped</b>
            <RemoveCircleIcon />
          </Box>
        )
      case State.successful:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Successful</b>
            <CheckCircleIcon />
          </Box>
        )
      case State.failed:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Failed</b>
            <ErrorIcon />
          </Box>
        )
      default:
        return (
          <Box className='pipelineStatus'>
            <b className='margin-right'>Not Found</b>
            <HelpIcon />
          </Box>
        )
    }
  }
}
